var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:url(#Degradado_sin_nombre_8);}.cls-3{fill:url(#Degradado_sin_nombre_8-2);}.cls-4{fill:url(#Degradado_sin_nombre_8-3);}.cls-10,.cls-5,.cls-6,.cls-7,.cls-9{mix-blend-mode:soft-light;}.cls-5{fill:url(#Degradado_sin_nombre_32);}.cls-6{fill:url(#Degradado_sin_nombre_32-2);}.cls-7{fill:url(#Degradado_sin_nombre_32-3);}.cls-8{fill:url(#Degradado_sin_nombre_8-4);}.cls-9{fill:url(#Degradado_sin_nombre_32-4);}.cls-10{fill:url(#Degradado_sin_nombre_32-5);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_8",
    x1: 475.59,
    y1: 404.98,
    x2: 168.16,
    y2: 406.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f84fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7b86ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_8-2",
    x1: 226.8,
    y1: 78.21,
    x2: 386.59,
    y2: 328.7,
    xlinkHref: "#Degradado_sin_nombre_8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_8-3",
    x1: 48.74,
    y1: 429.34,
    x2: 198.54,
    y2: 193.32,
    xlinkHref: "#Degradado_sin_nombre_8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_32",
    x1: 20.05,
    y1: 423.29,
    x2: 182.78,
    y2: 165.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_32-2",
    x1: 262.16,
    y1: 70.52,
    x2: 406.84,
    y2: 327.5,
    xlinkHref: "#Degradado_sin_nombre_32"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_32-3",
    x1: 454.94,
    y1: 412.46,
    x2: 166.49,
    y2: 439.17,
    xlinkHref: "#Degradado_sin_nombre_32"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_8-4",
    x1: 224.83,
    y1: 261.12,
    x2: 250.26,
    y2: 343.09,
    xlinkHref: "#Degradado_sin_nombre_8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_32-4",
    x1: 243.15,
    y1: 256.32,
    x2: 215.67,
    y2: 342.16,
    xlinkHref: "#Degradado_sin_nombre_32"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_32-5",
    x1: 209.22,
    y1: 324.53,
    x2: 297.77,
    y2: 324.53,
    xlinkHref: "#Degradado_sin_nombre_32"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M171.59,364.79l-29.52,46.27a22.88,22.88,0,0,0,19.29,35.18h312a24,24,0,0,0,20.22-36.93l-28.47-44.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M340.35,342.27h68.59a22.87,22.87,0,0,0,19.27-35.2L269.92,59.52a24,24,0,0,0-40.44,0l-35.06,54.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M236.29,221.5l-35.95-56.14a22.87,22.87,0,0,0-38.54,0L5.82,409.31A24,24,0,0,0,26,446.24H92.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M200.34,165.36l2.89,4.5L26,446.24h0A24,24,0,0,1,5.82,409.31l156-243.94A22.87,22.87,0,0,1,200.34,165.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M229.48,59.52l-3.42,5.36,179.4,277.39h3.48a22.87,22.87,0,0,0,19.27-35.2L269.92,59.52A24,24,0,0,0,229.48,59.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M491.16,405.51H145.61l-3.54,5.55a22.88,22.88,0,0,0,19.29,35.18h312a24,24,0,0,0,20.22-36.93Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "306.48 341.29 249.7 252.49 192.93 341.29 306.48 341.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "192.93 341.29 249.7 307.77 249.7 252.49 192.93 341.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "306.48 341.29 192.93 341.29 249.7 307.77 306.48 341.29"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndex);
export default __webpack_public_path__ + "static/media/index.29592058e71ed55c1a424d290e275564.svg";
export { ForwardRef as ReactComponent };